import { EnstructureLogo } from '@roko/ui/components/icons/EnstructureLogo'
import { Button } from '@roko/ui/components/ui/button'
import { IconHistory, IconPencil } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

type TTopNavigationProps = {
  sidebarTrigger?: ReactNode
  title?: string
  onNewChat?: () => void
  onOpenHistory?: () => void
  showMobileBrand?: boolean
}

export const TopNavigation = ({ sidebarTrigger, title, onNewChat, onOpenHistory, showMobileBrand = true }: TTopNavigationProps) => {
  const { t } = useTranslation()

  return (
    <header className="flex h-14 shrink-0 items-center justify-between gap-3 bg-card px-4 md:h-16 md:border-b md:border-border/60 md:px-6">
      <div className="flex min-w-0 items-center gap-2">
        {sidebarTrigger}
        {showMobileBrand && (
          <div className="md:hidden">
            <EnstructureLogo />
          </div>
        )}
        {title ? <h1 className="hidden truncate text-left text-lg font-semibold text-foreground md:block">{title}</h1> : null}
        {!title && <h1 className="sr-only">{t('app.name')}</h1>}
      </div>

      <div className="flex items-center gap-1">
        {onNewChat && (
          <Button type="button" variant="ghost" size="icon" className="md:hidden" onClick={onNewChat} aria-label={t('chat.createNewChat')}>
            <IconPencil className="size-5" stroke={1.5} />
          </Button>
        )}
        {onOpenHistory && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="md:hidden"
            onClick={onOpenHistory}
            aria-label={t('chat.recentChats')}
          >
            <IconHistory className="size-5" stroke={1.5} />
          </Button>
        )}
      </div>
    </header>
  )
}
